const reducer = (key, value) => {
    switch (key) {
        case 'code':
            if (typeof value !== 'string' || value.length > 20 || value.length < 1) return `It must be a character string with a maximun of 20 characters`
            break
        case 'phone_primary':
        case 'phone_secondary':
            if (typeof value !== 'string' || value.length > 20) return `It must be a character string with a maximun of 20 characters`
            break
        case 'name':
        case 'slug':
            if (typeof value !== 'string' || value.length > 50 || value.length < 1) return `It must be a character string with a maximun of 50 characters`
            break
        case 'email':
            if (typeof value !== 'string' || value.length > 200) return `It must be a character string with a maximun of 200 characters`
            break
        case 'postcode':
            if (typeof value !== 'string' || value.length > 16) return `It must be a character string with a maximun of 16 characters`
            break
        case 'address':
            if (typeof value !== 'string' || value.length > 255) return `It must be a character string with a maximun of 200 characters`
            break
        case 'lat':
        case 'lng':
            if (typeof value !== 'string' || Number.isNaN(Number(value))) return `Must be a number`
            break
        default:
            return null
    }
}

const validate = (values) => ({
    ...Object.keys(values).reduce((obj, k) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

export default validate
